import { forwardRef, useImperativeHandle, useState } from 'react';
import { BaseHelpPopup } from '../../../HelpPopup/__internal__';

/**
 * The IconHelpPopup used in ListColumnProps.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const IconHelpPopup = /*#__PURE__*/forwardRef(function IconHelpPopup(props, ref) {
  const [isOpen, setIsOpen] = useState(false);
  useImperativeHandle(ref, () => ({
    toggle: () => {
      const open = !isOpen;
      setIsOpen(open);
      return open;
    },
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    isOpen
  }));
  return /*#__PURE__*/_jsx(BaseHelpPopup, {
    ...props,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    focusable: false
  });
});
//# sourceMappingURL=IconHelpPopup.js.map